import { render, staticRenderFns } from "./ExchangeBtns.vue?vue&type=template&id=1308eaa1&scoped=true&"
import script from "./ExchangeBtns.vue?vue&type=script&lang=js&"
export * from "./ExchangeBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308eaa1",
  null
  
)

export default component.exports